module.exports = __webpack_public_path__ + "static/media/01A.db810e01.png";